import React, { useEffect, useState } from "react";
import { Step } from "../../../models/Step";
import "./EAStepper.scss";

interface IProps {
  steps: Step[];
  activeStep?: number;
  onStepChange?: (stepNumber: number) => void;
  hideSteps?: boolean;
}

const EAStepper: React.FC<IProps> = ({ steps, activeStep = 0, onStepChange, hideSteps = false }) => {
  const [currentStep, setCurrentStep] = useState(activeStep);

  useEffect(() => {
    setCurrentStep(activeStep);
  }, [activeStep]);

  const handleStepClick = (index: number) => {
    if (index <= currentStep) {
      setCurrentStep(index);
      if (onStepChange) onStepChange(index);
    }
  };

  return (
    <div className="stepper">
      {!hideSteps && (
        <div className="stepper__steps">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`stepper__step ${index <= currentStep ? "stepper__step--active" : ""}`}
              onClick={() => handleStepClick(index)}
            >
              <div className="stepper__circle">
                <p>{index + 1}</p>
              </div>
              <p className="stepper__label">{step.label}</p>
            </div>
          ))}
        </div>
      )}

      <div className="stepper__content">{steps[currentStep].content}</div>
    </div>
  );
};

export default EAStepper;
